import { render } from "./BarXScrollable.vue?vue&type=template&id=289bd8a9"
const script = {}

import "./BarXScrollable.vue?vue&type=style&index=0&id=289bd8a9&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__